export default {
  medicalDeviceRiskClasses: [],
  medicalDeviceRiskClass: undefined,
};
